import { z } from 'zod';

/**
 * Порт призначення в адресі сторінки (`?to=AEJEA`), §11 гайду: вибір видно в
 * посиланні й він переживає перезавантаження. Кривий код мовчки відкидається —
 * сторінка рахує до порту дилера чи системного.
 */
export const destinationSearch = z.object({
	to: z.string().regex(/^[A-Z]{2}[A-Z0-9]{3}$/).optional().catch(undefined),
});
